/**
 * Controller to launch MFA layout
 * @param primary Object the primary account
 * @param recovery_keys Array an array of recovery key objects, this is optional
 * If passed in, we use it for our collection. This is done because the final step in the MFA 
 * activation process returns recovery keys we want to use rather than fetching them again
 */
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import BreadcrumbNavLayout from '@/views/breadcrumb_nav_layout';
import MFALayout from '@/views/mfa/mfa_layout';

var globalCh = Radio.channel('global');
var routerCh = Radio.channel('router');

function show_mfa(primary, recovery_keys) {
    var features = globalCh.request('app_options', 'features');
    
    if (!features.show_mfa) {
        globalCh.request('home');
        return;
    }

    var app_container = globalCh.request('app_layout');

    var mfa_layout = new MFALayout({
        model: primary,
        collection: new Backbone.Collection(),
        title: 'Multi-Factor Authentication',
    });

    // Account mfa_enabled status may have changed, fetch it
    primary.fetch().done(function(r){
        
        if (primary.get('mfa_enabled') || recovery_keys) {
            primary.recovery_keys()
                .done(function (r) {
                    var recovery_keys = recovery_keys || r.recovery_keys;
                    mfa_layout.collection.add(recovery_keys);
                    app_container.showChildView('container', mfa_layout);
                    return;
                })
                .catch(function (err) {
                    console.warn('Could not load MFA layout');
                    return;
                });
        } else {
            // Show normal layout without recovery keys
            app_container.showChildView('container', mfa_layout);
        }
    });

    globalCh.request('show_secondary_nav', { empty: true });

    globalCh.request('show_profile_nav', { selected: 'mfa' });

    routerCh.request('set_location', 'mfa', primary);

    app_container.showChildView('main_nav', new BreadcrumbNavLayout());
    globalCh.request('changeActiveAccount', primary, function () {
        globalCh.request('set_selection', {
            type: 'app',
            id: 'home'
        });
    });

}

export default show_mfa;

